import type { AccountingBackfill, AccountingConnect, AccountingConnectionView, AccountingOverview, AccountingSettings, AccountingSyncItemView } from '@takeit4me/shared'
import type { Http } from '../http'

type In<T extends { _zod: { input: unknown } }> = T['_zod']['input']
export type AccountingConnectBody = In<typeof AccountingConnect>
export type AccountingSettingsBody = In<typeof AccountingSettings>
export type AccountingBackfillBody = In<typeof AccountingBackfill>
export interface AccountingRunResult { pushed: number; queued: number; checked: number; requeued: number; drift: number }

/** Console API methods: pushing invoices, payments and refunds to Xero or QuickBooks Online (B 7.6-04). */
export interface AccountingSyncApi {
  accountingConnection(): Promise<AccountingOverview>
  /** Starts a connection; open `authorize_url` to sign in with the provider. */
  connectAccounting(body: AccountingConnectBody): Promise<{ connection: AccountingConnectionView; authorize_url: string }>
  updateAccountingSettings(body: AccountingSettingsBody): Promise<AccountingConnectionView>
  disconnectAccounting(): Promise<{ ok: true }>
  backfillAccounting(body: AccountingBackfillBody): Promise<{ queued: number }>
  runAccounting(): Promise<AccountingRunResult>
  accountingItems(q?: { status?: string; invoice_id?: string; before?: string; limit?: number }): Promise<AccountingSyncItemView[]>
  resendAccountingItem(id: string): Promise<AccountingSyncItemView>
  invoiceAccounting(invoiceId: string): Promise<AccountingSyncItemView[]>
}

const enc = encodeURIComponent

export const accountingSyncMethods = (http: Http): AccountingSyncApi => ({
  accountingConnection: () => http.get<AccountingOverview>('/accounting/connection'),
  connectAccounting: (body) => http.post<{ connection: AccountingConnectionView; authorize_url: string }>('/accounting/connect', body),
  updateAccountingSettings: (body) => http.patch<AccountingConnectionView>('/accounting/connection', body),
  disconnectAccounting: () => http.delete<{ ok: true }>('/accounting/connection'),
  backfillAccounting: (body) => http.post<{ queued: number }>('/accounting/backfill', body),
  runAccounting: () => http.post<AccountingRunResult>('/accounting/run', {}),
  accountingItems: (q = {}) => http.get<AccountingSyncItemView[]>('/accounting/items', q),
  resendAccountingItem: (id) => http.post<AccountingSyncItemView>(`/accounting/items/${enc(id)}/resend`, {}),
  invoiceAccounting: (id) => http.get<AccountingSyncItemView[]>(`/commerce/invoices/${enc(id)}/accounting`),
})
